module.exports = __webpack_public_path__ + "84a27d325d55e7f941a3ff0501a0f7cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-purple.png
// module id = 1314
// module chunks = 0